import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Notification } from 'app/services/notification/notification.model';
import { EndRingTone, StartRingTone } from 'app/store/call/call.actions';
import { CreateNotification, DismissNotification } from 'app/store/notification/notification.actions';
import { NotificationState } from 'app/store/notification/notification.state';
import { Observable, Subject } from 'rxjs';
import { isBefore, sub } from 'date-fns';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'app-notifications-smart',
  templateUrl: './notifications-smart.component.html',
  styleUrls: ['./notifications-smart.component.scss'],
  standalone: false
})
export class NotificationsSmartComponent implements OnInit, OnDestroy {

  notifications$: Observable<Notification[]> = this.store.select(NotificationState.notifications);

  @Input() user: LenderUser;
  @Input() suppressNotifications: boolean = false;

  playAudioAlerts: boolean;
  destroyed$ = new Subject<void>();
  constructor(private store: Store) { }

  ngOnInit(): void {
    this.playAudioAlerts = this.user?.settings?.audioAlerts;
    this.hydrateSavedNotifications();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }

  dismiss(id: string) {
    this.store.dispatch(new DismissNotification(id));
  }

  startRingTone() {
    this.store.dispatch(new StartRingTone());
  }

  endRingTone() {
    this.store.dispatch(new EndRingTone());
  }

  private hydrateSavedNotifications() {
    let savedNotifications = JSON.parse(localStorage.getItem('savedNotifications') || '[]');
    if (savedNotifications.length) {
      savedNotifications.forEach((notification: Notification) => {
        // only patch into state if not older than 5 minutes, else removed from saved notifications local storage
        if (notification.created && !isBefore(new Date(notification.created), sub(new Date(), { minutes: 5 }))) {
          this.store.dispatch(new CreateNotification(notification, true));
        } else {
          savedNotifications = savedNotifications.filter((n: Notification) => n.id !== notification.id);
          localStorage.setItem('savedNotifications', JSON.stringify(savedNotifications));
        }
      });
    }
  }
}
